import request from '@/utils/request'

export function getMaintainStatusApi() {
  return request<'true' | 'false'>({
    url: '/getMaintainStatus',
    method: 'GET',
  })
}
